React = require 'react'
t = require('views/internal/recup-with-helpers')('nps')
track = require 'debug/track'
_ = require 'underscore'
$ = require 'jquery'
Util = require 'lib/util'

NUM_SHOWN_NOTIFICATIONS = 10
MAX_FEEDBACK_LENGTH = 256

taglines = [
  t.l(['recommend', '1'])
  t.l(['recommend', '2'])
  t.l(['recommend', '3'])
  t.l(['recommend', '4'])
]

module.exports = class NpsComponent extends React.Component
  displayName: 'HeaderNotifications'

  constructor: (props) ->
    this.state =
      visible: true
      feedback: ''
      stage: 'choose-score'

  render: t.renderable ->
    if !@state.visible
      return t.div()

    t.div '.nps-container', =>
      t.div '.nps-dismiss', =>
        t.a '.quiet', {
          onClick: (e) =>
            if @state.score?
              @props.submitSurvey({
                completed: false
                score: @state.score
                trackScore: true
              })
              track('NPS', 'Dismiss', 'With Score')
            else
              track('NPS', 'Dismiss', 'Without Score')

            @props.onDismiss()
        }, ->
          t.format 'close'

      switch @state.stage
        when 'choose-score'
          @renderChooseScore()
        when 'follow-up'
          @renderFollowUp()
        when 'complete-promoter'
          @renderCompletePromoter()
        when 'complete-passive'
          @renderCompletePassive()
        when 'complete-detractor'
          @renderCompleteDetractor()

  renderChooseScore: ->
    submitScore = (score) =>
      (e) =>
        Util.stop(e)
        @setState
          score: score
          stage: 'follow-up'
        @props.submitSurvey({
          completed: true
          score: score
          trackScore: true
        })

    t.p '.nps-prelude', ->
      t.format 'we-want-to-know'

    t.h2 '.nps-question', ->
      t.format 'how-likely-are-you-to-recommend-trello-to-others'

    t.div '.nps-buttons', ->
      for score in [0..10]
        t.button '.nps-button', { onClick: submitScore(score) }, ->
          t.text score

    t.div '.quiet.nps-explanation', ->
      t.div '.nps-low', ->
        t.format 'not-likely'
      t.div '.nps-spacing', ->
      t.div '.nps-high', ->
        t.format 'very-likely'

  renderFollowUp: ->
    onSubmit = (e) =>
      Util.stop(e)
      @setState
        stage:
          switch @state.score
            when 9, 10
              'complete-promoter'
            when 6, 7, 8
              'complete-passive'
            when 0, 1, 2, 3, 4, 5
              'complete-detractor'

      @props.submitSurvey({
        completed: true
        score: @state.score
        comment: @state.feedback
        usage: @state.usage
        trackUsage: true
      })

    setUsage = (usage) =>
      (e) =>
        Util.stop(e)
        @setState
          usage: usage

    onBack = (e) =>
      Util.stop(e)
      track('NPS', 'Click Back')
      @setState(stage: 'choose-score')

    t.p '.nps-back-container.quiet', ->
      t.span '.nps-back', { onClick: onBack }, ->
        t.span '.icon-sm.icon-back'
        t.text " "
        t.span '.nps-back-text', ->
          t.format 'back'

    t.p '.nps-prelude', ->
      t.format 'thanks-one-more-quick-thing'

    t.h2 '.nps-question', ->
      t.format 'tell-us-more-about-that-score'

    t.textarea '.nps-feedback', {
      maxLength: MAX_FEEDBACK_LENGTH,
      defaultValue: @state.feedback,
      placeholder: t.l('were-all-ears') + " 👂"
      onInput: (e) =>
        @setState(feedback: e.target.value)
    }

    t.div '.nps-remaining.quiet', =>
      remaining = MAX_FEEDBACK_LENGTH - @state.feedback.length
      if remaining == 0
        t.format 'you-re-out-of-room-send-more-via'
        t.a { href: '/contact', target: 'contact' }, ->
          t.format 'our-contact-page'

      else if remaining < 100
        t.text remaining

    t.h2 '.nps-question', ->
      t.format 'how-do-you-use-trello'

    t.div '.nps-uses', =>
      for usage in ['business', 'personal', 'both']
        t.button '.nps-use', {
          class: t.classify({ 'nps-use-selected': usage == @state.usage })
          onClick: setUsage(usage)
        }, ->
          t.format ['usage', usage]

    t.button '.nps-submit', {
      onClick: onSubmit
    }, ->
      t.format 'submit'

  renderCompletePromoter: ->
    onClick = (e) =>
      Util.stop(e)
      @setState(visible: false)

      track('NPS', 'Complete Promoter', 'Click Tweet')
      window.open 'https://twitter.com/intent/tweet?' + $.param({
        text: _.sample(taglines),
        url: "https://trello.com/#{ this.props.username }/recommend",
        related: "trello,TacoTrello"
      })

    onDismiss = =>
      track('NPS', 'Complete Promoter', 'Click Finish')
      @setState(visible: false)

    t.p '.nps-submitted', ->
      t.format 'submitted'

    t.div '.nps-illustration', ->
      t.img '.nps-illustration-image', { src: require('images/stickers/taco-love@2x.png') }

    t.p '.nps-follow-up', ->
      t.format 'we-love-your-enthusiasm'

    t.p ->
      t.img '.nps-twitter-icon', { src: require('images/nps/twitter.svg') }
      t.format 'care-to-share'

    t.button '.nps-tweet', { onClick }, ->
      t.format 'tweet-about-trello'

    t.button '.nps-finish', { onClick: onDismiss }, ->
      t.format 'finish'

  renderCompletePassive: ->
    onClick = (e) =>
      Util.stop(e)
      @setState(visible: false)
      track('NPS', 'Complete Passive', 'Click Game')
      window.open '/taco-out'

    onDismiss = (e) =>
      Util.stop(e)
      @setState(visible: false)
      track('NPS', 'Complete Passive', 'Click Finish')

    t.p '.nps-submitted', ->
      t.format 'feedback-submitted'

    t.div '.nps-illustration', ->
      t.img '.nps-illustration-image', { src: require('images/stickers/taco-celebrate@2x.png') }

    t.p '.nps-follow-up', ->
      t.format 'thanks-for-your-time'

    t.p ->
      t.format 'not-ready-to-get-back-to-work'

    t.button '.nps-game', { onClick }, ->
      t.format 'play-a-game-with-taco'

    t.button '.nps-finish', { onClick: onDismiss }, ->
      t.format 'finish'

  renderCompleteDetractor: ->
    onClick = (e) =>
      Util.stop(e)
      @setState(visible: false)
      track('NPS', 'Complete Detractor', 'Click Contact Support')
      window.open '/contact'

    onDismiss = (e) =>
      Util.stop(e)
      @setState(visible: false)
      track('NPS', 'Complete Detractor', 'Click Finish')

    t.p '.nps-submitted', ->
      t.format 'feedback-submitted'

    t.div '.nps-illustration', ->
      t.img '.nps-illustration-image', { src: require('images/stickers/taco-alert@2x.png') }

    t.p '.nps-follow-up', ->
      t.format 'we-re-sorry-to-hear-that'

    t.p ->
      t.format 'is-there-anything-we-can-do-to-help'

    t.button '.nps-support', { onClick }, ->
      t.format 'contact-support'

    t.button '.nps-finish', { onClick: onDismiss }, ->
      t.format 'finish'



// WEBPACK FOOTER //
// ./app/scripts/views/nps/nps-component.coffee